export const ONBOARDING_WIZARD_STEPS = 7;

/** Footer stepper dots — Figma 16940:6280 (7 dots for steps 1–6; step 7 loading/success hides stepper). */
export const ONBOARDING_STEPPER_STEPS = 7;

/** @deprecated Use ONBOARDING_STEPPER_STEPS for footer dots. */
export const ONBOARDING_TOTAL_STEPS = ONBOARDING_STEPPER_STEPS;

export type OnboardingTrainingPackageValue = 'essentials' | 'pro' | 'plus';

export type OnboardingStatus = 'incomplete' | 'completed' | 'abandoned';

export interface OnboardingTrainingTopic {
  id: string;
  name: string;
}

/** Client-side wizard state — persisted to API only on final submit (Phase 1 backend). */
export interface OnboardingFormData {
  /** CEE-992 — explicit opt-in only; default false until user chooses Set up with AI. */
  aiRecommendationEnabled: boolean;
  companyName: string;
  companyWebsite: string;
  trainingPackage: OnboardingTrainingPackageValue | '';
  industry: string;
  employeeCount: string;
  employeeTerminology: string;
  speakUpSolution: string;
  regions: string[];
  brandSkipped: boolean;
  /** null = not chosen; true/false maps to branding guidelines Yes/No (Step 5). */
  brandGuidelines: boolean | null;
  primaryBrandColor: string;
  secondaryBrandColor: string;
  trainingTopics: OnboardingTrainingTopic[];
  priorityMonths: string[];
  monthsToAvoid: string[];
  additionalContext: string;
}

export const emptyOnboardingFormData = (): OnboardingFormData => ({
  aiRecommendationEnabled: false,
  companyName: '',
  companyWebsite: '',
  trainingPackage: '',
  industry: '',
  employeeCount: '',
  employeeTerminology: '',
  speakUpSolution: '',
  regions: [],
  brandSkipped: false,
  brandGuidelines: null,
  primaryBrandColor: '',
  secondaryBrandColor: '',
  trainingTopics: [],
  priorityMonths: [],
  monthsToAvoid: [],
  additionalContext: '',
});

export type OnboardingWizardStep = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type OnboardingWizardView = 'steps' | 'reassign';

export type OnboardingStep6Phase = 'submitting' | 'success' | 'error';
